import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Contacts from "@material-ui/icons/Contacts";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import "react-quill/dist/quill.snow.css";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { retroPoolService } from "services/retroPoolService";
import { useParams, useHistory } from "react-router-dom";
import Button from "../../components/CustomButtons/Button";
import { Box } from "@material-ui/core";
import { formateCreatedAt } from "../../helper/fommaters";
import RetroPoolActivity from "views/PuushdotPool/RetroPoolActivity";

const useStyles = makeStyles(styles);

export default function RetroPoolView() {
  const { id } = useParams();
  const history = useHistory();
  const [info, setInfo] = React.useState({});
  const [activityData, setActivityData] = React.useState([]);
  const [size] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [count, setCount] = React.useState(0);

  async function fetchData(id) {
    const { data } = await retroPoolService.view(id);
    setInfo(data);
  }

  async function fetchDataActivity(id) {
    const payload = {
      page: +page,
      size: +size,
      sortBy: "createdAt",
      sortType: "asc",
    };
    const { data } = await retroPoolService.activityList(id, payload);
    setActivityData(data.items);
    setCount(+data.paginate.count);
    setPage(+data.paginate.page);
  }

  React.useEffect(() => {
    fetchData(id);
    fetchDataActivity(id);
  }, [page]);

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Contacts />
            </CardIcon>
            <h4 className={classes.cardIconTitle}> Pool ID: {info.poolId} </h4>
          </CardHeader>

          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Nft Contract:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.nftContract}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Token Contract:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.tokenContract}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Project Fee Receiver:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.projectFeeReceiver}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Project Fee Amount:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.projectFeeAmount}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Max Nft Supply:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.maxNftSupply}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Min Nft Supply:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.minNftSupply}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Current Nft Supply:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.currentNftSupply}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Max Token Supply:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.maxTokenSupply}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Current Token Supply:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.currentTokenSupply}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Active:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.active === true ? "True" : "False"}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Public Deposits Locked:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.publicDepositsLocked === true ? "True" : "False"}</h5>
              </GridItem>
            </GridContainer>

            {/* <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Price:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.price}</h5>
              </GridItem>
            </GridContainer> */}

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Created At:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{formateCreatedAt(info.createdAt)}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer className="ml-2">
              <Box m={2} pt={3}>
                <Button onClick={() => history.goBack()}>Cancel</Button>
              </Box>
            </GridContainer>
            <h4>
              <strong>Pools Activity: </strong>
            </h4>
            <RetroPoolActivity
              items={activityData ? activityData : []}
              setPage={setPage}
              page={page}
              count={count}
              size={size}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
